<template>
    <div>
        <h1>D-Wurf</h1>
        <h3 style="margin-bottom: 64px">09.05.2025</h3>

        <div class="image">
             <img src="../../assets/img/D-Wurf/D-Wurf.jpeg" alt="D-Wurf">
        </div>

        <DogParents :mom="mom" :dad="dad"/>

        <div class="puppies">
            <div class="puppy">
                <h2>Die Frida</h2>
                <h4>geb. 09.05.2025 15:30 Uhr, 415g, Kennfarbe lila, Hündin</h4>
                <ImageCard :images="lila"/>
            </div>
            <div class="puppy">
                <h2>Dayuki</h2>
                <h4>geb. 09.05.2025 17:07 Uhr, 360g, Kennfarbe orange, Hündin</h4>
                <ImageCard :images="orange"/>
            </div>
            <div class="puppy">
                <h2>Doktor Watson</h2>
                <h4>geb. 09.05.2025 17:14 Uhr, 375g, Kennfarbe dunkelgrün, Rüde</h4>
                <ImageCard :images="darkgreen"/>
            </div>
            <div class="puppy">
                <h2>Dorn</h2>
                <h4>geb. 09.05.2025 17:36 Uhr, 415g, Kennfarbe blau, Rüde</h4>
                <ImageCard :images="blue"/>
            </div>
            <div class="puppy">
                <h2>Don Comet</h2>
                <h4>geb. 09.05.2025 18:07 Uhr, 390g, Kennfarbe gelb, Rüde</h4>
                <ImageCard :images="yellow"/>
            </div>
            <div class="puppy">
                <h2>Don Carlo</h2>
                <h4>geb. 09.05.2025 18:22 Uhr, 385g, Kennfarbe hellgrün, Rüde</h4>
                <ImageCard :images="lightgreen"/>
            </div>
        </div>
    </div>
</template>

<script>
import ImageCard from '../../components/ImageCard.vue';
import DogParents from '../../components/DogParents.vue';

export default {
  name: 'App',
  data() {
    return {
        mom: {
            name: "Khaleesi von den Wolfswiesen",
            bday: "geb.23.04.2018",
            img_face: require("../../assets/img/Khali_Face_small.jpg"),
            img_side: require("../../assets/img/Khali_Side.jpg")
        },
        dad: {
            name: "Amon vom Weißtal",
            bday: "geb. 11.04.2023",
            img_face: require("../../assets/img/D-Wurf/Amon-Face.jpeg"),
            img_side: require("../../assets/img/D-Wurf/Amon-Side.jpeg")
        },
        orange: {
            woche1: require("../../assets/img/D-Wurf/Woche1/orange.jpg"),
            abgabe: require("../../assets/img/D-Wurf/Abgabe/Dayuki.jpeg"),
            halbesJahr: require("../../assets/img/D-Wurf/HalbesJahr/Dayuki.jpg"),
            jahr: require("../../assets/img/D-Wurf/Jahr/Dayuki.jpg"),
        },
        darkgreen: {
            woche1: require("../../assets/img/D-Wurf/Woche1/dunkelgruen.jpg"),
            abgabe: require("../../assets/img/D-Wurf/Abgabe/Watson.jpg"),
            halbesJahr: require("../../assets/img/D-Wurf/HalbesJahr/Doctor.jpg"),
            jahr: require("../../assets/img/D-Wurf/Jahr/Watson.jpg"),
        },
        blue: {
            woche1: require("../../assets/img/D-Wurf/Woche1/blau.jpg"),
            abgabe: require("../../assets/img/D-Wurf/Abgabe/Dorn.jpeg"),
            halbesJahr: require("../../assets/img/D-Wurf/HalbesJahr/Dorn.jpg"),
            jahr: require("../../assets/img/D-Wurf/Jahr/Dorn.jpg"),
        },
        lila: {
            woche1: require("../../assets/img/D-Wurf/Woche1/lila.jpg"),
            abgabe: require("../../assets/img/D-Wurf/Abgabe/Frida.jpeg"),
            halbesJahr: require("../../assets/img/D-Wurf/HalbesJahr/Frida.jpg"),
            jahr: require("../../assets/img/D-Wurf/Jahr/Frida.jpg"),
        },
        lightgreen: {
            woche1: require("../../assets/img/D-Wurf/Woche1/hellgruen.jpg"),
            abgabe: require("../../assets/img/D-Wurf/Abgabe/Carlo.jpeg"),
            halbesJahr: require("../../assets/img/D-Wurf/HalbesJahr/Carlo.jpg"),
            jahr: require("../../assets/img/D-Wurf/Jahr/Carlo.jpg"),
        },
        yellow: {
            woche1: require("../../assets/img/D-Wurf/Woche1/gelb.jpg"),
            abgabe: require("../../assets/img/D-Wurf/Abgabe/Comet.jpeg"),
            halbesJahr: require("../../assets/img/D-Wurf/HalbesJahr/Comet.jpg"),
            jahr: require("../../assets/img/D-Wurf/Jahr/Comet.jpg"),
        }
    }
  },
  components: {
    ImageCard,
    DogParents
    },
    props: ["onZuchtstaette"],
    emits: ["update-zuchtstaette-nav-on", "update-zuchtstaette-nav-off"],
    mounted() {
        this.$emit("update-zuchtstaette-nav-on")
    },
    unmounted() {
        this.$emit("update-zuchtstaette-nav-off")
    }
}
</script>

<style scoped>
:root {
  --backgroundColor: #dcdece;
  --mainText: #333D29;
  --mainTextLight: #70875A;
  --linkText: #936639;
  --focusedText: #582F0E;
  --higlightedText: #04A0A2;
}

h1 {
    margin-bottom: 0px;
}

h3 {
    color: var(--mainTextLight);
}

h4 {
    color: var(--mainTextLight);
    margin-bottom: 16px;
}

h2 {
    margin-bottom: 0px;
}

.image {
    display: grid;
    justify-content: center;
    align-items: center;
}

img {
    max-width: 750px;
    width: 100%;
    height: auto;
    margin-bottom: 32px;
    border-radius: 8px;
}

.puppies {
    display: grid;
    gap: 64px 0px;
}

h4 {
    display: flex;
}

i {
    color: var(--mainTextLight);
    font-size: 0.8em;
}
</style>